import { List, Typography } from '@mui/material';
import SportBackgroundListItem from './SportBackgroundListItem';
import { ISportBackground } from '../../../../../interfaces/sport.interface';

interface ISportBackgroundListProps {
  sportBackgrounds: ISportBackground[];
  isLoading: boolean;
  isError: boolean;
  error?: string;
}

const SportBackgroundList = (props: ISportBackgroundListProps) => {
  const { sportBackgrounds, isLoading, isError } = props;

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  if (isError) {
    return (
      <Typography>
        {'Oops! Something went wrong, we can’t load sport backgrounds.'}
      </Typography>
    );
  }

  if (sportBackgrounds.length === 0) {
    return <Typography>No achievements available</Typography>;
  }

  return (
    <List
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: '16px', md: '22px' },
      }}
    >
      {sportBackgrounds.map((sportBackground) => (
        <SportBackgroundListItem
          key={sportBackground.id}
          sportBackground={sportBackground}
        />
      ))}
    </List>
  );
};

export default SportBackgroundList;
